import { APIS } from '../../../../utils/api-factory'
import LocalStrorageUtility from '../../../../utils/localStorageUtil'
import moment from 'moment'
import axios from 'axios'
import { TENANT_HEADER ,TENANT_POST_HEADER} from '../../../../utils/apiHeaders'

export const getExotelcallHisotryListByFilters = (type, status, startDate, endDate,page,size, callBack, error) => {
    axios.get(APIS.GET_EXOTEL_CALL_LOGS_BY_FITLERS + type + "&status=" + status + "&startDate=" + startDate + "&endDate=" + endDate + "&page=" + page + "&size=" + size, TENANT_HEADER)
        .then(res => {
            callBack(res?.data)
        })
        .catch(e => {
            callBack("")
        })
}

export const PushExotelDataforcall = (templateId, data, callBack, error) => {
    const headerconfig = {
        headers: TENANT_POST_HEADER
    }
    axios.post(APIS.PUSH_EXOTEL_DATA_FOR_CALL + templateId,data,headerconfig )
        .then(res => {
            callBack(res?.data)
        })
        .catch(e => {
            callBack("")
        })
}